module.exports = __webpack_public_path__ + "static/media/image_card_1.6b5c5a2d.png";